module.exports = __webpack_public_path__ + "img/green_079.ab04e702.png";